module.exports = __webpack_public_path__ + "assets/normal/images/logo.52211b30.png";